import BrandLogo from "../BrandLogo";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useAuthActions } from "@convex-dev/auth/react";
import AppleIcon from "@mui/icons-material/Apple";
import GoogleIcon from "@mui/icons-material/Google";
import GitHubIcon from "@mui/icons-material/GitHub";
import "./signup.css";

export default function Signup() {
  const { signIn } = useAuthActions();
  const [pending, setPending] = useState<string | null>(null);
  const [error, setError] = useState("");
  async function continueWith(provider: string) {
    setPending(provider);
    setError("");
    try {
      await signIn(provider, { redirectTo: new URL("/timeline", window.location.origin).href });
    } catch {
      setError("We couldn’t connect to that sign-in provider. Please try again.");
    } finally {
      setPending(null);
    }
  }
  return <main className="join-page">
    <header><Link className="join-brand" to="/"><BrandLogo /></Link><Link to="/about">About the archive ↗</Link></header>
    <div className="join-layout">
      <aside><div className="join-eyebrow">FOLLOW YOUR CURIOSITY</div><h1>All of history.<br />Your own journey.</h1><p>Find your next listen by time and place. Explore the stories you love, and discover where they lead.</p><div className="join-journey"><span>ANCIENT WORLD</span><b>From the first cities…</b><i /><span>AGE OF EXPLORATION</span><b>…to worlds colliding…</b><i /><span>MODERN HISTORY</span><b>…and the world we know.</b></div><small>Your next chapter is waiting.</small></aside>
      <section className="join-card" aria-labelledby="join-title" aria-busy={pending !== null}>
        <div className="join-eyebrow">MAKE IT YOURS</div><h2 id="join-title">Start your history journey.</h2><p>Sign in or create your account to explore the archive and keep your listening progress.</p>
        {[{id:"apple",name:"Apple",Icon:AppleIcon},{id:"google",name:"Google",Icon:GoogleIcon},{id:"github",name:"GitHub",Icon:GitHubIcon}].map(({id,name,Icon}) => <button key={id} type="button" className="join-provider" disabled={pending !== null} onClick={() => void continueWith(id)}><Icon aria-hidden="true" fontSize="small" />{pending === id ? "Connecting…" : `Continue with ${name}`}</button>)}
        {error && <p className="join-error" role="alert">{error}</p>}
        <div className="join-divider">Your account lets you</div><ul><li>Explore by time and place</li><li>Listen to history podcasts</li><li>Keep your listening history</li></ul><small className="join-note">Continue with your preferred provider to sign in securely.</small>
      </section>
    </div>
  </main>;
}
